import { createStore } from "owa-satcheljs";

interface RewardsPointsStore {
    // Measured points-text pixel width keyed by coprincipal account key. Replaced wholesale on write
    // so the `pointsWidthByAccount` property read stays MobX-tracked without an ObservableMap.
    pointsWidthByAccount: {
        [accountKey: string]: number;
    };
    panelOpenedByAccount: {
        [accountKey: string]: boolean;
    };
    buttonVisibilityAccountKey: string;
    isButtonVisibleInHeader: boolean;
}

const getRewardsPointsStore: () => RewardsPointsStore = createStore<RewardsPointsStore>("rewardsPointsStore", {
    pointsWidthByAccount: {},
    panelOpenedByAccount: {},
    buttonVisibilityAccountKey: "",
    isButtonVisibleInHeader: false,
});

export default getRewardsPointsStore;
